// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GvV7BDSHKEqPaQ {
  background: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.xJM_gd_GpGM0yl {
  flex-grow: 0;
  flex-shrink: 0;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  color: var(--accent-text, var(--ds-icon-subtle, #626f86));
}
.xJM_gd_GpGM0yl:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.xJM_gd_GpGM0yl:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.xJM_gd_GpGM0yl:visited,
.xJM_gd_GpGM0yl:active {
  outline: none;
}
.xJM_gd_GpGM0yl:focus {
  outline: -webkit-focus-ring-color auto 1px;
}
@media print {
  .xJM_gd_GpGM0yl {
    display: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `GvV7BDSHKEqPaQ`,
	"cardTemplateButton": `xJM_gd_GpGM0yl`
};
export default ___CSS_LOADER_EXPORT___;
